import { createSlice, createAsyncThunk  } from "@reduxjs/toolkit";
import { getCompany } from "sr/utils/api/company/getCompany";

export const fetchCompany = createAsyncThunk('fetchCompany', async (params:any)=>{
    const queryParams = new URLSearchParams();
    if (params?.id) queryParams.append('id', params?.id)
        const response = await getCompany(queryParams)
    if(response?.success===true){
        return response?.data
    }
    })
interface CompanyState {
    data:any,
    isLoading: boolean;
    isError: boolean
}    
const initialState:CompanyState =  {
    isLoading: false,
    data: null,
    isError: false
}
const CompanySlice = createSlice({
    name:'Company',
    initialState,
    extraReducers:(builder)=>{
        builder.addCase(fetchCompany.pending, (state, action)=>{
                state.isLoading = true
        })
                    builder.addCase(fetchCompany.fulfilled, (state, action) => {

                        
                        state.data = action.payload;
                    })
                    builder.addCase(fetchCompany.rejected, (state, action) => {
                        state.isError = true;
        
                    });
    },
    reducers:undefined
})
export default CompanySlice.reducer